<template>
  <div class="container">
    <LineChart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"
      class="graph"/>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
  name: 'CsatChartClient',
  components: { LineChart },
   data() {
   return {
    loaded: true, 
    chartdata: {
      labels: ['Mon, 13-3-21', 'Tue, 14-3-21', 'Wed, 15-3-21', 'Thu, 16-3-21', 'Fri, 17-3-21', 'Sat, 18-3-21', 'Sun, 19-3-21'],
      datasets: [
        {
          label: 'Daily Active users',
          borderColor: "rgba(56, 80, 104, 0.8)",
          pointBackgroundColor: "rgba(171, 71, 188, 1)",
          data: [545, 450, 345, 457, 300, 632, 423]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
   }
   }
// -------------------- Chart with API data --------------------- //
//   data: () => ({
//     loaded: false,
//     chartdata: null
//   }),
//   async mounted () {
//     this.loaded = false
//     try {
//       const { userlist } = await fetch('/api/userlist')
//       this.chartdata = userlist
//       this.loaded = true
//     } catch (e) {
//       console.error(e)
//     }
//   }
}
</script>